<template>
  <div class="wrapper">
    <div id="map-container"></div>
    <h3 style="font-size: 20px; font-weight: 500;">{{ $t('personal_info') }}</h3>
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-layout class="form-wrapper" wrap>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="client.code"
            :error-messages="errors.code"
            :label="$t('nin')"
            :rules="[required]"
            name="code"
            autofocus
            @blur="checkForErrors('code')"
          />
        </v-flex>

        <v-flex xs12 sm6>
          <v-text-field
              v-model="client.vat_payer_code"
              :error-messages="errors.vat_payer_code"
              :label="$t('vat_payer_code')"
              name="vat_payer_code"
              @blur="checkForErrors('vat_payer_code')"
          />
        </v-flex>

        <v-flex xs12 sm8>
          <v-text-field
            v-model="client.email"
            :error-messages="errors.email"
            :label="$t('email_address')"
            :hint="$t('email_confirmation')"
            :rules="[required]"
            name="email"
            @blur="checkForErrors('email')"
          />
        </v-flex>

        <v-flex xs12 sm4>
          <v-checkbox
            v-model="client.is_newsletter_recipient"
            :label="$t('i_want_to_receive_newsletters')"
            style="float: right"
            name="is_newsletter_recipient"
          />
        </v-flex>

        <v-flex sm4 xs12>
          <v-text-field
            v-model="client.first_name"
            :error-messages="errors.name"
            :rules="[required]"
            :label="$t('first_name')"
            name="first_name"
            @blur="checkForErrors('name')"
          />
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field
            v-model="client.last_name"
            :rules="[required]"
            :label="$t('last_name')"
            name="last_name"
          />
        </v-flex>

        <v-flex sm4 xs12>
          <v-text-field
            v-model="client.phone"
            :error-messages="errors.phone"
            :rules="[required]"
            :label="$t('phone')"
            name="phone"
            @blur="checkForErrors('phone')"
          />
        </v-flex>

        <v-flex class="text-xs-center" xs12>
          <AddressSearch :is-required="!showAddressFields" @addressSelected="onAddressSelect"/>
        </v-flex>

        <template v-if="showAddressFields">
          <v-flex xs12 sm6>
            <v-text-field
              v-model="client.address_street"
              :error-messages="errors.address_street"
              :label="$t('street')"
              :rules="[required]"
              class="company-form-input"
              name="address_street"
              @input="setPostalCode(addressString)"
              @blur="checkForErrors('address_street')"
            />
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="client.address_nr"
              :error-messages="errors.address_nr"
              :label="$t('building_flat_no')"
              :rules="[required]"
              class="company-form-input"
              name="address_nr"
              @input="setPostalCode(addressString)"
              @blur="checkForErrors('address_nr')"
            />
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="client.address_city"
              :error-messages="errors.address_city"
              :label="$t('city')"
              :rules="[required]"
              class="company-form-input"
              name="address_city"
              @input="setPostalCode(addressString)"
              @blur="checkForErrors('address_city')"
            />
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="client.address_post_code"
              :error-messages="errors.address_post_code"
              :label="$t('postal_code')"
              :rules="[postCode]"
              class="company-form-input"
              name="address_post_code"
              disabled
              @blur="checkForErrors('address_post_code')"
            />
          </v-flex>
        </template>
      </v-layout>
      <v-btn type="submit" color="primary" class="primary-btn">{{ $t('continue') }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import formMixin from '../mixins/form-mixin';
import googleMapsPlacesMixin from '../mixins/google-maps-places-mixin';
import AddressSearch from '../components/AddressSearch.vue';

export default {
  name: 'PrivatePersonForm',

  components: { AddressSearch },

  mixins: [formMixin, googleMapsPlacesMixin],

  data() {
    return {
      showAddressFields: false,
    };
  },

  created() {
    if (this.client.address_post_code || this.client.address_street
      || this.client.address_nr || this.client.address_city) {
      this.showAddressFields = true;
    }
    this.storeClientType('private');
  },

  computed: {
    ...mapState({
      client: state => state.clients.privateFormItem,
      errors: state => state.clients.errors,
    }),

    addressString() {
      return `${this.client.address_street} ${this.client.address_nr} ${this.client.address_city}`;
    },
  },

  methods: {
    ...mapMutations({
      storeClientType: 'clients/storeType',
      setAddressFields: 'clients/setAddressFields',
      clearErrors: 'clients/clearErrors',
    }),

    onSubmit() {
      // showAddressFields check is put there because with Chrome autocomplete, address search
      // field is filled (so it passes required validation)
      if (!this.$refs.form.validate() || !this.showAddressFields) {
        return;
      }
      this.$router.push({ name: 'agreements' });
    },

    checkForErrors(field) {
      if (this.errors[field].length) {
        this.clearErrors(field);
      }
    },

    onAddressSelect(val) {
      this.showAddressFields = true;
      this.setAddressFields(val);
    },
  },
};
</script>

<style scoped>
  .wrapper {
    padding: 0 36px;
  }
</style>
